import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormControl } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class ErrorMessageService {
  private translate = inject(TranslateService);


  public getErrorMessage(formGroup, formControl) {
    if (formGroup.controls[formControl].hasError('required')) {
      return this.translate.instant('ERROR_MESSAGE.REQUIRED');
    }

    if (formGroup.controls[formControl].hasError('minlength')) {
      return this.translate.instant('ERROR_MESSAGE.MINLENGTH',
        { value: formGroup.controls[formControl].errors.minlength.requiredLength });
    }

    if (formGroup.controls[formControl].hasError('maxlength')) {
      return this.translate.instant('ERROR_MESSAGE.MAXLENGTH',
        { value: formGroup.controls[formControl].errors.maxlength.requiredLength });
    }

    if (formGroup.controls[formControl].hasError('whitespace')) {
      return this.translate.instant('ERROR_MESSAGE.WHITESPACE');
    }

    if (formGroup.controls[formControl].hasError('pattern')) {
      return this.translate.instant('ERROR_MESSAGE.PATTERN');
    }

    if (formGroup.controls[formControl].hasError('min')) {
      return this.translate.instant('ERROR_MESSAGE.MIN',
        { value: formGroup.controls[formControl].errors.min.min });
    }

    if (formGroup.controls[formControl].hasError('max')) {
      return this.translate.instant('ERROR_MESSAGE.MAX',
        { value: formGroup.controls[formControl].errors.max.max });
    }

    if (formGroup.controls[formControl].hasError('json')) {
      return this.translate.instant('ERROR_MESSAGE.JSON');
    }

    if (formGroup.controls[formControl].hasError('minLengthArray')) {
      return this.translate.instant('ERROR_MESSAGE.MINLENGTHARRAY',
        { value: formGroup.controls[formControl].errors.minLengthArray.minRequired });
    }
  }

  getErrorMessageUsingFormControl(formControl: FormControl) {
    if (formControl.hasError('required')) {
      return 'You must enter a value';
    }

    if (formControl.hasError('minlength')) {
      return `Min length is ${formControl.errors.minLength.requiredLength}`;
    }

    if (formControl.hasError('maxlength')) {
      return `Max length is ${formControl.errors.maxlength.requiredLength}`;
    }

    if (formControl.hasError('whitespace')) {
      return `Field cannot be empty`;
    }

    if (formControl.hasError('pattern')) {
      return `Invalid input`;
    }

    if (formControl.hasError('min')) {
      return `Min is ${formControl.errors.min.min}`;
    }

    if (formControl.hasError('max')) {
      return `Max is ${formControl.errors.max.max}`;
    }

    if (formControl.hasError('json')) {
      return `Invalid JSON!`;
    }

    if (formControl.hasError('minLengthArray')) {
      return `Please select at least ${formControl.errors.minLengthArray.minRequired} item.`;
    }

    if (formControl.hasError('schemaInValid')) {
      return `Invalid JSON!`;
    }
  }
}
